import { render, staticRenderFns } from "./serach.vue?vue&type=template&id=820f72fa&scoped=true&"
import script from "./serach.vue?vue&type=script&lang=js&"
export * from "./serach.vue?vue&type=script&lang=js&"
import style0 from "./serach.vue?vue&type=style&index=0&id=820f72fa&lang=less&scoped=true&"
import style1 from "./serach.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820f72fa",
  null
  
)

export default component.exports